const notIncludedInBase = (extra) => !extra.include_in_base;

export default notIncludedInBase;
